import axiosRequest from '../constants/axios-request'
import { Training } from '../types/training'

export const getTrainings = (): Promise<Training[]> =>
  axiosRequest.get('/training').then((result) => result.data)

export const getTraining = (
  trainingId: string | undefined
): Promise<Training> =>
  axiosRequest
    .get(`/training/${trainingId}`)
    .then((result) => result.data)
    .catch((error) => error.status)

export const addTraining = (payload: {
  training: Omit<Training, 'categories' | 'id'>
  trainingGroupId: string
}): Promise<number> =>
  axiosRequest
    .post(`/training`, payload)
    .then((result) => result.status)
    .catch((error) => error.response.status)

export const updateTraining = (
  trainingId: string,
  payload: Omit<Training, 'categories' | 'id'>
): Promise<number> =>
  axiosRequest
    .put(`/training/${trainingId}`, payload)
    .then((result) => result.status)
    .catch((error) => error.response.status)

export const deleteTraining = (
  trainingId: string | undefined
): Promise<number> =>
  axiosRequest
    .delete(`/admin/training/${trainingId}`)
    .then((result) => result.status)
    .catch((error) => error.response.status)
